import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "../../utils/axiosConfig";

const FilteredBodyGeorutas = ({
    // OJO: este listGeorutas realmente es "lista de contratos" o "lista base" que trae trayecto
    listGeorutas = [],

    showAll = false,
    selectedIds = [],
    setShowAll,
    setSelectedIds,
    filterActive,
}) => {
    const [searchGeo, setSearchGeo] = useState("");
    const [listGeorutasState, setListGeorutasState] = useState([]);

    // ✅ normaliza trayectos desde la lista base (contratos)
    const trayectosStr = useMemo(() => {
        const unique = new Set();

        (Array.isArray(listGeorutas) ? listGeorutas : []).forEach((item) => {
            const t = Number(
                item?.IDTrayecto ??      // ✅ tu campo real
                item?.idtrayecto ??
                item?.trayecto ??
                item?.IdTrayecto ??
                0
            );
            if (!Number.isFinite(t) || t <= 0) return;
            unique.add(t);
        });

        return Array.from(unique).sort((a, b) => a - b).join(",");
    }, [listGeorutas]);


    // ✅ fetch georutas activas solo cuando cambie la lista de trayectos
    useEffect(() => {
        if (!trayectosStr) {
            setListGeorutasState([]);
            return;
        }

        let cancelled = false;

        axios
            .post(
                process.env.REACT_APP_SERVER + "/maestros/getgeorutasactivas",
                { trayectos: trayectosStr },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                }
            )
            .then((response) => {
                if (cancelled) return;
                if (response.data?.success) {
                    console.log("Georutas activas obtenidas:", response.data.data);
                    setListGeorutasState(response.data.data);
                } else {
                    setListGeorutasState([]);
                }
            })
            .catch((error) => {
                if (cancelled) return;
                console.error("Error al listar georutas:", error);
                setListGeorutasState([]);
            });

        return () => {
            cancelled = true;
        };
    }, [trayectosStr]);

    // ====== UI tipo geocercas (checkbox + buscar + seleccionar todo) ======
    const getId = (g) => g?.IDTrayecto ?? g?.IDtrayecto ?? g?.IdTrayecto ?? g?.id ?? g?.ID;

    const getName = (g) =>
        g?.DescripcionTrayecto ??   // ✅ tu campo real
        g?.DescriptionTrayecto ??
        g?.Descripcion ??
        g?.Nombre ??
        "Sin nombre";


    const normalized = useMemo(() => {
        return (Array.isArray(listGeorutasState) ? listGeorutasState : [])
            .map((g) => ({
                raw: g,
                id: String(getId(g) ?? ""),
                name: String(getName(g) ?? ""),
            }))
            .filter((x) => x.id && x.id !== "undefined" && x.id !== "null");
    }, [listGeorutasState]);

    const filteredNormalized = useMemo(() => {
        const t = searchGeo.trim().toLowerCase();
        if (!t) return normalized;
        return normalized.filter((g) => {
            const name = (g.name || "").toLowerCase();
            const id = (g.id || "").toLowerCase();
            return name.includes(t) || id.includes(t);
        });
    }, [normalized, searchGeo]);

    const selectedSet = useMemo(() => {
        return new Set((Array.isArray(selectedIds) ? selectedIds : []).map(String));
    }, [selectedIds]);

    const total = filteredNormalized.length;
    const checkedCount = useMemo(() => {
        if (showAll) return 0;
        let c = 0;
        for (const g of filteredNormalized) if (selectedSet.has(g.id)) c++;
        return c;
    }, [showAll, filteredNormalized, selectedSet]);


    const allChecked = !showAll && total > 0 && checkedCount === total;
    const someChecked = !showAll && checkedCount > 0 && checkedCount < total;

    const selectAllRef = useRef(null);
    useEffect(() => {
        if (selectAllRef.current) selectAllRef.current.indeterminate = someChecked;
    }, [someChecked]);

    // ✅ Si activas “mostrar todas”, limpia selección
    useEffect(() => {
        if (showAll && Array.isArray(selectedIds) && selectedIds.length) {
            setSelectedIds?.([]);
            filterActive?.({ showAll: true, selectedIds: [] });
        }

    }, [showAll]);

    const handleToggleShowAll = (checked) => {
        setShowAll?.(checked);
        if (checked) setSelectedIds?.([]);
        filterActive?.({ showAll: checked, selectedIds: [] });
    };

    const toggleOne = (id) => {
        if (showAll) return;

        setSelectedIds?.((prev) => {
            const set = new Set((Array.isArray(prev) ? prev : []).map(String));
            if (set.has(id)) set.delete(id);
            else set.add(id);

            const next = Array.from(set);
            filterActive?.({ showAll: false, selectedIds: next });
            return next;
        });
    };


    const toggleSelectAllChecks = (checked) => {
        if (showAll) return;

        requestAnimationFrame(() => {
            const next = checked ? filteredNormalized.map((x) => x.id) : [];
            setSelectedIds?.(next);
            filterActive?.({ showAll: false, selectedIds: next });
        });
    };


    return (
        <div className="geo-filter mpr">
            <div className="geo-filter__header">
                <label className={`geo-row ${showAll ? "is-on" : ""}`}>
                    <input
                        type="checkbox"
                        className="geo-check"
                        checked={!!showAll}
                        onChange={(e) => handleToggleShowAll(e.target.checked)}
                    />
                    <span className="geo-label">Mostrar todas</span>
                </label>

                <label className={`geo-row ${allChecked || someChecked ? "is-on" : ""}`} style={{ opacity: showAll ? 0.5 : 1 }}>
                    <input
                        ref={selectAllRef}
                        type="checkbox"
                        className="geo-check"
                        checked={allChecked}
                        onChange={(e) => toggleSelectAllChecks(e.target.checked)}
                        disabled={showAll || total === 0}
                    />
                    <span className="geo-label">Seleccionar todas</span>

                    {!showAll && total > 0 && <span className="geo-meta">{checkedCount}/{total}</span>}
                </label>
            </div>

            {/* ✅ BUSCADOR */}
            <div className="geo-search">
                <input
                    className="geo-search__input"
                    type="text"
                    value={searchGeo}
                    onChange={(e) => setSearchGeo(e.target.value)}
                    placeholder="Buscar georuta..."
                    disabled={normalized.length === 0}
                />
                {searchGeo.trim() !== "" && (
                    <button
                        type="button"
                        className="geo-search__clear"
                        onClick={() => setSearchGeo("")}
                        aria-label="Limpiar búsqueda"
                        title="Limpiar"
                    >
                        ×
                    </button>
                )}
            </div>

            <div className="geo-filter__list" style={{ opacity: showAll ? 0.6 : 1 }}>
                {trayectosStr === "" ? (
                    <div className="geo-empty">No hay trayectos válidos</div>
                ) : normalized.length === 0 ? (
                    <div className="geo-empty">No hay georutas</div>
                ) : filteredNormalized.length === 0 ? (
                    <div className="geo-empty">No hay resultados</div>
                ) : (
                    filteredNormalized.map((g) => {
                        const checked = !showAll && selectedSet.has(g.id);
                        return (
                            <label
                                key={g.id}
                                className={`geo-row geo-item ${checked ? "is-on" : ""} ${showAll ? "is-disabled" : ""}`}
                                title={g.name}
                            >
                                <input
                                    type="checkbox"
                                    className="geo-check"
                                    checked={checked}
                                    onChange={() => toggleOne(g.id)}
                                    disabled={showAll}
                                />
                                <span className="geo-label geo-name">{g.name}</span>
                            </label>
                        );
                    })
                )}
            </div>

            <style>{`
        .geo-filter{ width:100%; display:flex; flex-direction:column; gap:10px; }
        .geo-filter__header{
          display:flex; flex-direction:column; gap:8px;
          padding:10px; border:1px solid rgba(0,0,0,.08);
          border-radius:10px; background:rgba(0,0,0,.02);
        }
        .geo-search{ position:relative; display:flex; align-items:center; }
        .geo-search__input{
          width:100%; padding:10px 34px 10px 12px;
          border-radius:10px; border:1px solid rgba(0,0,0,.12); outline:none;
        }
        .geo-search__input:focus{
          border-color: rgba(0,102,153,.45);
          box-shadow: 0 0 0 3px rgba(0,102,153,.12);
        }
        .geo-search__clear{
          position:absolute; right:8px; width:24px; height:24px;
          border:none; border-radius:50%; background:rgba(0,0,0,.06);
          cursor:pointer; display:flex; align-items:center; justify-content:center;
          font-size:18px; line-height:1;
        }
        .geo-search__clear:hover{ background:rgba(0,0,0,.10); }

        .geo-filter__list{
          max-height:50vh; overflow:auto; padding:10px;
          border:1px solid rgba(0,0,0,.08);
          border-radius:10px; background:#fff;
        }
        .geo-row{
          display:flex; align-items:center; gap:10px;
          padding:8px 8px; border-radius:10px;
          cursor:pointer; user-select:none;
          border:1px solid transparent;
          transition:background .15s ease,border-color .15s ease;
        }
        .geo-row:hover{ background:rgba(0,0,0,.03); }
        .geo-row.is-on{ background:rgba(0,102,153,.10); border-color:rgba(0,102,153,.25); }
        .geo-item.is-disabled{ cursor:not-allowed; }
        .geo-meta{ margin-left:auto; font-size:12px; color:rgba(0,0,0,.55); }
        .geo-name{ white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:100%; }
        .geo-empty{ text-align:center; color:#666; padding:12px 6px; }

        .geo-check{
          -webkit-appearance:none !important;
          appearance:none !important;
          width:16px; height:16px; flex:0 0 16px; margin:0;
          border:2px solid rgba(0,0,0,.35);
          border-radius:3px; background:#fff;
          display:grid; place-items:center;
          cursor:pointer; position:relative;
        }
        .geo-check:checked{ border-color:#006699; background:#006699; }
        .geo-check:checked::after{
          content:""; width:8px; height:4px;
          border-left:2px solid #fff;
          border-bottom:2px solid #fff;
          transform: rotate(-45deg);
          margin-top:-1px;
        }
        .geo-check:disabled{ cursor:not-allowed; opacity:.6; }
        .geo-check:indeterminate{ border-color:#006699; background:#006699; }
        .geo-check:indeterminate::after{ content:""; width:8px; height:2px; background:#fff; }

        @media (max-width: 768px) {
                
                    .geo-filter__list{ max-height:30vh;  }
                }
      `}</style>
        </div>
    );
};

export default FilteredBodyGeorutas;
